import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from 'react';

/** Removes the leading `#` from the hash */
function parseHash(hash: string): string | null {
  return hash.length === 0 ? null : hash.substring(1);
}
function subscribe(onChange: () => void) {
  window.addEventListener('hashchange', onChange);
  window.addEventListener('popstate', onChange);
  return () => {
    window.removeEventListener('hashchange', onChange);
    window.removeEventListener('popstate', onChange);
  };
}

/** Reads the URL hash (without `#`) and re-renders on every hash change. Navigate with a native `#…` anchor or `window.location.hash`, which fire `hashchange`. */
export default function useHash() {
  const $ = _c(2);
  const hash = useSyncExternalStore(subscribe, _temp, _temp2);
  const t0 = hash as T | null;
  let t1;
  if ($[0] !== t0) {
    t1 = [t0];
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1 as const;
}
function _temp2() {
  return null;
}
function _temp() {
  return parseHash(window.location.hash);
}